import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "bar", "text"];

  update() {
    const strength = this.getPasswordStrength(this.inputTarget.value);
    const percentage = (strength / 5) * 100;

    this.barTarget.style.setProperty('--strength-width', `${percentage}%`);

    const colors = ['#ef4444', '#f59e0b', '#eab308', '#22c55e', '#16a34a'];
    const texts = ['Very Weak', 'Weak', 'Fair', 'Good', 'Strong'];

    if (this.inputTarget.value.length === 0) {
      this.textTarget.textContent = 'Enter a strong password';
      this.barTarget.style.background = '#e5e7eb';
    } else {
      this.textTarget.textContent = texts[strength - 1] || 'Very Weak';
      this.barTarget.style.background = colors[strength - 1] || colors[0];
    }
  }

  getPasswordStrength(password) {
    let strength = 0;
    if (password.length >= 8) strength++;
    if (/[a-z]/.test(password)) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/[0-9]/.test(password)) strength++;
    if (/[^A-Za-z0-9]/.test(password)) strength++;
    return strength;
  }
}
